import styled from 'styled-components'
import { dimensions, light } from '~/constants/theme'

export const ListViewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: ${dimensions.sidebarWidth}px;
  background-color: ${light.gray200};
`
export const DetailViewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`
export const DetailViewNoContentWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  background-color: ${light.gray300};
`
